//import { environment } from './../../../../environments/environment';
import { ProspectModel } from './../../../model/ProspectModel';
import { DashboardComponent } from './../../../pages/dashboard/dashboard.component';
 
 
import { ProductModel, DeviceElement, DevicePriceInfo   } from './../../../model/selfcareproducts';
import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { PeriodModel } from 'src/app/model/PeriodModel';
import { ModemDevice } from 'src/app/model/ModemDevice';
import { debug } from 'util';
import { NewProspectModel } from 'src/app/model/newProspectModel';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CustomerProspectService } from 'src/app/services/customer-prospect.service';
import { CyberPay, CyberPayLogModel, CyberPaySetTransactionRequest } from 'src/app/model/CyberPay';
import { PaymentService } from 'src/app/services/payment.service';
import { Utilities } from 'src/app/services/common/Utility';
import { ConfigurationService } from 'src/app/services/common/configuration.service';
import { environment } from 'src/environments/environment';
import { properties, UploadFile } from 'ng-zorro-antd';
import { Guid } from 'guid-typescript';
import { Prospect } from 'src/app/model/Prospect';
import { PaymentModel } from 'src/app/model/PaymentModel';
import { CyberPayPaymentRequest } from 'src/app/model/CyberPayPaymentRequest';
import { ToastrService } from 'ngx-toastr';
import { HttpEventType, HttpClient } from '@angular/common/http';
import { Observable, Observer } from 'rxjs';

@Component({
  selector: 'app-checkout-content',
  templateUrl: './checkout-content.component.html',
  styleUrls: ['./checkout-content.component.css']
})
export class CheckoutContentComponent implements OnInit {

  displayProducts : ProductModel[];
   servicePlanAmount : string; 
  selectedProductID: number = 0;
  periods :PeriodModel [] =[];
  selectedPeriodID : number=0;
  selectedPeriod : string;
  AmountPayable: number = 0;

   modemDevices :      DevicePriceInfo []=[];// DeviceElement[]=[];
   selectedModemID:number;
   selectedModem:string;
   selectedModemPrice:number = 0;;
   currentproductPrice:number=0;

   ModemName: string;
   ModemPrice:number;
   ModemNAVCode:string;
   ModemNAVPrice :number;

   ProductName:string;
   ProductID:number;
   
   
   ProductPrice :number;
   PeriodNo:number;


   DeliveryAddress:string;
   FirstName:string;
   LastName:string;
   EmailAddress: string;
   MobilePhone:string;

   prospectForm:FormGroup;
   

   uploading = false;
   fileList1: UploadFile[] = [];
   fileList2: UploadFile[] = [];

   public progress: number;
   public message: string;
   @Output() public onUploadFinished = new EventEmitter();

   
  constructor(private  customerService: CustomerProspectService ,
    private paymentService: PaymentService,
     private config: ConfigurationService, private toastrService:ToastrService, private formBuilder: FormBuilder, private http:HttpClient) {
    
    this.servicePlanAmount = '₦' + '0.00';
    this.  bindProducts();
    this.generatePeriods();

    const emailPattern = '^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$';
    this.prospectForm = this.formBuilder.group({
      FirstName: [null, [Validators.required]],
      LastName: [null, [Validators.required]],
      EmailAddress: [null, [Validators.required,   Validators.pattern(emailPattern)]],
      MobilePhone: [null, [Validators.required,  Validators.pattern("^[0-9]*$")]],
      DeliveryAddress: [null, [Validators.required]],
      
    
    });
    
   }
 
   changeService(id:number){
     
     
       var product = this.displayProducts.find(e => e.i_product == id);
      this.selectedProductID = id
     this.servicePlanAmount =  product.DisplayName;     
     this.currentproductPrice =product.Price;
     
      var counter = 0;
     this.modemDevices = product.Devices;
     this.modemDevices.forEach(x1 => x1.Name = "₦" + x1.Price.toLocaleString() + " - " + x1.Device);
     this.modemDevices.forEach(x1 => x1.id =  ++counter);
     this.ProductName =product.Name;
     this.ProductID=product.i_product;
     this.ProductPrice=product.Price;
     
     
   
    
     




     // Calculate total payment
    if (id>0)
     {
       var currentproductPrice = product.Price;
        var currentperiod :PeriodModel =this.periods.find(e => e.id == this.selectedPeriodID); 
      var currentModem :DevicePriceInfo  = this.modemDevices.find(e => e.id == this.selectedModemID);
      this. AmountPayable = (currentproductPrice * this. selectedPeriodID) + this.selectedModemPrice;
     
    



     }
   
    }


    beforeUpload1 = (file: UploadFile) => {

      return new Observable((observer: Observer<boolean>) => {
        const isImage = file.type.startsWith('image');
  
        if (isImage) {
          const isLt3M = file.size / 1024 / 1024 < 3;
          if (!isLt3M) {
            this.toastrService.error('file must be smaller than 3MB!');
            observer.complete();
            return;
          }
          this.fileList1 = this.fileList1.concat(file);
          observer.next(false);
          observer.complete();
  
  
  
        } else {
          this.toastrService.error('You can only upload image file');
          observer.complete();
          return;
        }
  
      });
    }
    
    beforeUpload2 = (file: UploadFile) => {

      return new Observable((observer: Observer<boolean>) => {
        const isImage = file.type.startsWith('image');
  
        if (isImage) {
          const isLt3M = file.size / 1024 / 1024 < 3;
          if (!isLt3M) {
            this.toastrService.error('file must be smaller than 3MB!');
            observer.complete();
            return;
          }
          this.fileList2 = this.fileList2.concat(file);
          observer.next(false);
          observer.complete();
  
  
  
        } else {
          this.toastrService.error('You can only upload image file');
          observer.complete();
          return;
        }
  
      });
    }
    
    


    changePeriod(id:number)
    {
     
      var period = this.periods.find(e => e.id == id);
      this.selectedPeriod = period.Name;
      this.selectedPeriodID = period.id;
      this. AmountPayable = (this.currentproductPrice * this. selectedPeriodID) + this.selectedModemPrice;
      this.PeriodNo = period.id;

    }

    public uploadFile = (CustID:number) => {
     /* if (files.length === 0) {
        return;
      }*/
   
      let KyCFile :any =           this.fileList1[0];
      let UtilityBill :any =           this.fileList2[0];
      
      
      //var KYCFileName:string= 
      const formData = new FormData();
      formData.append('KYCfile', KyCFile, KyCFile.name);
      formData.append('UtilityBill', UtilityBill, UtilityBill.name);
      formData.append('CustID',CustID+"");
       var uploadur :string= `${environment.lteHttpBaseUrl}/api/v1/upload`;
   
      this.http.post(uploadur, formData, {reportProgress: true, observe: 'events'})
        .subscribe(event => {
          if (event.type === HttpEventType.UploadProgress)
            this.progress = Math.round(100 * event.loaded / event.total);
          else if (event.type === HttpEventType.Response) {
            this.message = 'Upload success.';
            this.onUploadFinished.emit(event.body);
          }
        });
    }


  bindProducts()
  {
    this.displayProducts = JSON.parse(localStorage.getItem('displayProducts'));
       this. displayProducts.sort((a,b)=> a.Price - b.Price);
    
  
  
  }
  changeModem(id : number)
  {
    var modem = this.modemDevices.find(e => e.id == id);
    this.selectedModemID = modem.id;
    this.selectedModem= modem.Name;
    this.selectedModemPrice = modem.Price;
    this. AmountPayable = (this.currentproductPrice * this. selectedPeriodID) + this.selectedModemPrice;


    this.ModemName=  modem.Device;
    this.ModemPrice=modem.Price;
    this.ModemNAVCode=modem.NAVCode;
    this.ModemNAVPrice =modem.NAVPrice;
  }
  generatePeriods()
  {
  
    var period1: PeriodModel = {id: 1, Name:'1 Month' };
 
       
       
     this.periods.push(period1);
     for (let i = 2; i < 25; i++) {
      
      var newPeriod: PeriodModel = {id: i, Name: i + ' months' };
    
      this.periods.push(newPeriod);


      
    }
 
  }
  onSubmit(formGroup: FormGroup)
  {

      var prospect: Prospect = {} as Prospect;
      prospect.MobilePhone = formGroup.value.MobilePhone;
      prospect.FirstName= formGroup.value.FirstName;
      prospect.LastName= formGroup.value.LastName;
      prospect.EmailAddress= formGroup.value.EmailAddress;
      prospect.AmountPayable =this.AmountPayable;
      prospect.AddressStreet =   formGroup.value.DeliveryAddress;
 

 

 
    let today = new Date().toISOString().slice(0, 10);
    let date: Date = new Date();  
    
    if(!prospect.FirstName || !prospect.LastName || !prospect.EmailAddress  || !prospect.MobilePhone)
    {
      this.toastrService.error("User information required!");
      return;
      
    }
    if(!this.fileList1[0] || !this.fileList2[0])
    {
      this.toastrService.error("Utility Bills and ID documents are rquired... ");

      return;
    }
   // prospect.MerchantRef=MerchantRef;
   prospect.CreatedBy = prospect.FirstName + " " + prospect.LastName;
   prospect.CreationDate = date;
   prospect.ContactMethod =  prospect.ContactMethod == null ? "Email" : prospect.ContactMethod;
   prospect.OperatorCode = this.config.OperatorCode;
   prospect.AddressStreet = this.DeliveryAddress  ;
   prospect.AddressArea = "N";
   prospect.AddressZip="NA";
   prospect.AddressCity = "NA";
   prospect.AddressState = "NA";
   prospect.AddressCountry="NA";
   prospect.ProductID = this.ProductID;
   prospect.Device1 =this. ModemName;
   prospect.Device1Cost = this.ModemPrice;
   prospect.Device1NAVCode =this. ModemNAVCode;
   prospect.Device1NAVCost = this.ModemNAVPrice;
   prospect.NoofDays = this.selectedPeriodID;
   
   let paymentModel : PaymentModel = Utilities.MapProspect(prospect);
   // map before posting to endpint
    
    this.customerService.savenewProspect(paymentModel).subscribe(    
      data => {    
            
        if(data.Status==1)    
        {   
          var paymentModel :  PaymentModel = data.Result;  
          try{
             var CustID:number =  paymentModel.Customer.ProspectID;

            this.uploadFile(CustID);
          }
          catch{}

          
          var portalcode :string;
         var  OperatorID: number = this.config.OperatorID;
          var  resuiredPortalCode:string = "PortalCode" + OperatorID;
          resuiredPortalCode  =resuiredPortalCode==this.config.PortalCode1 ? this.config.PortalCode1:this.config.PortalCode4;

          
          let cyberPay = {} as CyberPay;
          cyberPay. RedirectLink = prospect.Provider;
          cyberPay.portalCode =resuiredPortalCode;
          cyberPay.CustomerID = paymentModel.Customer.ProspectID;
          cyberPay.provider_id = prospect.ProviderId;
          cyberPay.CustomerDesc = "Prospect Reference No";
          cyberPay.Email = paymentModel.Customer.EmailAddress;
          cyberPay.Value = prospect.AmountPayable ;
          cyberPay.  FullName = paymentModel.Customer.FirstName + " " + paymentModel.Customer.LastName;
          cyberPay.Session = "NewSignUp-"+ paymentModel.Customer.ProspectID + "-" +  Guid.create().toString().toUpperCase().split('-').join('')
          cyberPay. ItemCode =this. ModemNAVCode ;
          cyberPay. ItemName = "Prospect";
          cyberPay.PhoneNumber = paymentModel.Customer.MobilePhone;
          cyberPay.amount = prospect.AmountPayable  ;
          cyberPay.i_product = this.ProductID  ;
        
         this.PostCyberpay(cyberPay);
        

         //  
         
        }    
        else{   
       
           this.toastrService.error( data.Message); 
          
              
       //   this.errorMessage = data.Message;    
         // this.alertService.error(this.errorMessage);
        }    
      },     
      error => {    
         
       // this.loading = false;  
      //  this._notificationservice.error("Error logging in"); 

       
      }); 

  }
  ngOnInit()
   {


    
  }

  PostCyberpay(cyberPay: CyberPay)
  {
 
    let cyberPayModel = {} as CyberPay;
    let MerchantRef = Guid.create().toString().toUpperCase().split('-').join('');
    
    
    cyberPay.RedirectLink= environment.CyberPayReturnURL;                    //this.config.CyberPayReturnURL;
   
    let cyberPayPaymentRequest = {} as CyberPaySetTransactionRequest;
    cyberPayPaymentRequest.Currency = "NGN";
    cyberPayPaymentRequest.CustomerId = cyberPay.CustomerID.toString();
    cyberPayPaymentRequest.Amount =  cyberPay.amount* 100;
     cyberPayPaymentRequest.CustomerEmail = cyberPay.Email;
    cyberPayPaymentRequest.MerchantRef =MerchantRef;
    cyberPayPaymentRequest.CustomerMobile= cyberPay.PhoneNumber;
    cyberPayPaymentRequest.CustomerName=cyberPay.FullName ;
    cyberPayPaymentRequest.Description = cyberPay.ItemName + "-" + cyberPay.i_account;
    cyberPayPaymentRequest.IntegrationKey=environment.IntegrationKey;
     cyberPayPaymentRequest.ReturnUrl = environment.CyberPayReturnURL;
     cyberPayPaymentRequest.ProductCode = cyberPay.i_product.toString();
     cyberPayPaymentRequest.WebhookUrl = environment.webhookUrl;
     
     
    
   let serialisedPayload :string = JSON.stringify(cyberPayPaymentRequest).toString();


     
    this.paymentService.cyberPaySetTransaction(cyberPayPaymentRequest).subscribe(    
      res => {    
        
        if(res.succeeded== true)    
        {       
          


          let date: Date = new Date();
       
            

            var robj = res.data;
            var redirectUr = robj.redirectUrl;
            var transactionReference =robj. transactionReference;
            //var TheObj = robj.data;
            //var redirectUr = TheObj.redirectUrl;
            
  
          
            window.location.href = redirectUr;


   // Log Cyberpay Request

  
   let cyberPayLogModel = {} as CyberPayLogModel;

   cyberPayLogModel.CustomerDesc = cyberPay.CustomerDesc;
   cyberPayLogModel.CustomerID = cyberPay.CustomerID;
   cyberPayLogModel.DateCreated= date.toDateString();
   cyberPayLogModel.Email=cyberPay.Email;
   cyberPayLogModel.FullName = cyberPay.FullName;
   cyberPayLogModel.IsSuccessful = false;
   cyberPayLogModel.ItemCode = cyberPay.ItemCode;
   cyberPayLogModel.ItemName = cyberPay.ItemName;
   cyberPayLogModel.OperatorID = cyberPay.OperatorID;
   cyberPayLogModel.PhoneNumber = cyberPay.PhoneNumber;
   cyberPayLogModel.PortalCode = cyberPay.portalCode;
   cyberPayLogModel.RedirectLink=cyberPay.RedirectLink;
   cyberPayLogModel.Request_Payload=serialisedPayload;
   cyberPayLogModel.Session=cyberPay.Session;
   cyberPayLogModel.Transaction_status="PENDING";;
   cyberPayLogModel.Value =cyberPay.amount;
   cyberPayLogModel.amount = cyberPay.amount;
   cyberPayLogModel.i_account=cyberPay.i_account;
   cyberPayLogModel.i_customer=cyberPay.i_customer;
   cyberPayLogModel.i_product = cyberPay.i_product;
   cyberPayLogModel.TransRef = transactionReference;
 

   
  
 
   this.paymentService.LteHttpLogCyberPayRequest(cyberPayLogModel).subscribe(res=>{
    console.log(res);
  });


   

       

         // window.location.href = data.data.redirectUrl;


     
          
        

         // this.router.navigate(['/dashboard']);    
         
        }    
        else{   
       
          //this._notificationservice.error("Error logging in"); 
          
              
       //   this.errorMessage = data.Message;    
         // this.alertService.error(this.errorMessage);
        }    
      },     
      error => {    
         
       // this.loading = false;  
      //  this._notificationservice.error("Error logging in"); 

       
      }); 


  }

}
